<template>
  <!-- Tabla -->
 
    <div class="flex justify-between">
      <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&lt;TablaTotalesCentro&gt;</span>
      <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">  api/v1/presupuestos/centro </span>
    </div>
 
  <div class="overflow-x-auto">
     
    <table class="w-full text-sm text-gray-700">
      <!-- THEAD -->
      <thead 
  class="uppercase text-xs tracking-wide font-mono"
  :class="borrador 
    ? 'bg-gradient-to-r from-green-800 to-emerald-400 text-white' 
    : 'bg-gray-100 text-gray-600'"
>
        <tr>
          <th class="text-left px-6 py-3">Categoría</th>
          <th class="text-right px-6 py-3">Presupuesto {{ aa_consulta }}</th>
          <th class="text-right px-6 py-3">Gastos</th>
          <th class="text-left px-6 py-3">% Ejecución</th>
        </tr>
      </thead>

      <!-- TBODY -->
      <tbody>
        <tr
          v-for="(item, index) in presupuesto_categorias"
          :key="index"
          class="border-b hover:bg-gray-50 transition font-mono"
          :class="{ 'bg-gray-50': index % 2 !== 0 }"
        >
          <!-- Nombre -->
          <td class="px-6 py-3 font-medium text-gray-800">
            <a class="text-blue-700 underline" :href="'#' + item.nombre.normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/\s+/g, '-')">{{ item.nombre }}</a>
          </td>

          <!-- Presupuesto -->
          <td class="px-6 py-3 text-right font-mono">
            $ {{ $formatoMiles(item.total_presupuesto) }}
          </td>
          <!-- Presupuesto -->
          <td class="px-6 py-3 text-right font-mono">
           $ {{ $formatoMiles(item.total_gastos) }}
          </td>
          <!-- Porcentaje -->
          <td class="px-6 py-3 text-right font-mono text-white">
             <div class="w-full bg-gray-300 rounded h-6 overflow-hidden">
<div
                  class="h-6 pt-1   transition-all duration-300 text-xs"
                  :class="{
                    'bg-blue-500': item.total_gastos / item.total_presupuesto < 0.5,
                    'bg-yellow-500': item.total_gastos / item.total_presupuesto >= 0.5 && item.total_gastos / item.total_presupuesto < 0.8,
                    'bg-red-500': item.total_gastos / item.total_presupuesto >= 0.8
                  }"
                  :style="{
                    width: item.total_presupuesto > 0
                      ? Math.min((item.total_gastos / item.total_presupuesto) * 100, 100) + '%'
                      : '0%'
                  }"
                >
               &nbsp;{{
              item.total_presupuesto > 0
                ? (( item.total_gastos * 100) / item.total_presupuesto  ).toFixed(1)
                : '0%'
            }} 
              
              </div>
</div>

            
          </td>
        </tr>
      </tbody>

      <!-- TFOOT -->
      <tfoot class="bg-gray-100">
        <tr>
          <td class="px-6 py-3 font-semibold text-gray-800">TOTAL GENERAL</td>
          <td class="px-6 py-3 text-right font-semibold font-mono">$ {{ $formatoMiles(total_presupuesto_centro)}}</td>
          
           <td   class="px-6 py-3 text-right font-semibold font-mono text-gray-700"  >
           $ {{ $formatoMiles(total_gastos_centro)}}
          </td>
          <td  class="px-6 py-3 text-left font-semibold font-mono text-gray-700" >
              <div class="flex items-center gap-3"> 
              <span class="  text-right">
                      {{((tot_tabla1.gastos / tot_tabla1.presupuestos) * 100).toFixed(1) }} %  
              </span>
               <div v-if="loading">
                 <div  class="w-4 h-4 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>  
               </div>
              </div>   
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import api from "@/api/axios";
import { useCatPresup } from "@/composables/useCatPresup";
export default {
  name: "TablaTotalesCentros",
  props: {
    centro_id: {
      type: Number,
      required: true
    },
     date_time: {
      type: String,
      
    },
    prop_incluyeCero:{
      type:Boolean
    },
    borrador:{
      type:Boolean
    }
  },
  mounted(){
    this.inicializar()
    this.categoriasAgrupadas()
  },
  computed: {
    tot_tabla1() {
    return this.presupuesto_categorias.reduce(
      (acc, item) => {
        acc.presupuestos += Number(item.total_presupuesto || 0);
        acc.gastos += Number(item.total_gastos || 0);
      
        return acc;
      },
      { presupuestos: 0, gastos: 0  }
    );
  },
  },
   watch: {
    date_time: function(){
         this.categoriasAgrupadas()
    },
    centro_id: function () {
     // console.log('montando', value, this.centro_id)
       this.categoriasAgrupadas()
    },
    prop_incluyeCero: function(){
       this.incluyeCero = this.prop_incluyeCero;
    }
  },
  data() {
    return {
      valor: "",
      listado: {},
      categorias: {},
      tipos: {},

      cuentamodif: 0,
      
      total_presupuesto_centro: 0,
      presupuesto_categorias: [],
      total_gastos_centro:0,
      loading:false,
      incluyeCero:false,
      año:0,
      aa_consulta: 0
    } 
  },
  methods: {
    inicializar(){
        this.aa_consulta =  this.$store.state.auth.userLogin.año  
        if (this.borrador)
        {
            this.aa_consulta = this.$store.state.auth.userLogin.año_borrador
        }
    },
    
    async categoriasAgrupadas() {
      // recupera cuentas con presupuestos ingresados
      this.loading=true;
      let presupuestos;
      try {
        const data = {
          centro_id: this.centro_id,
        };
        if (this.incluyeCero) {
          data["incluyeCero"] = this.incluyeCero;
        }
        if (this.borrador){
          data["borrador"] = this.borrador
        }
        // solo trae presupuestos > 0
        const response = await api.post("api/v1/presupuestos/centro/", data, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200) {
          this.año= response.data.año;
          presupuestos = response.data.presupuestos;

          /*  
               contiene el mismo centro_id
               en todos sus registros

               los cuenta_id no se repiten
               
               "presupuestos": 
               [
                    {
                        "id": 5816,
                        "centro_id": 6,
                        "cuenta_id": 8,
                        "empresa_id": 1,
                        "aa": 2025,
                        "moneda_id": 1,
                        "total_presupuesto": "900000.00",
                        "total_gastos": "0.00"
                    },
                    
                  v/s   this.$store.state.cuentas.cuentas
                  [{
                    "id":112,
                    "codigo":"4.5.1030.80.44",
                    "nombre":"Alarma",
                    "tipo_cuenta":{
                    "id":13,
                    "nombre":"GTOS BASICOS CASAS E INSTALACIONES",
                    "categoria_cuenta":{
                        "id":8,
                        "nombre":"GASTOS GENERALES"
                    }
                    }
                  */

         

          const cuentas = this.$store.state.cuentas.cuentas;
          const { getCatPresup } = useCatPresup();
          this.categorias = getCatPresup(presupuestos, cuentas);
         
       
         // ordenar por atributo 'orden'
        this.categorias = Object.values(this.categorias).sort((a, b) => 
          (a.orden ?? Infinity) -
          (b.orden ?? Infinity)
        );
          this.loading = false;
        
        }
/*
[
    {
        "id": 5,
        "nombre": "COMUNICACIONES y GESTION INSTITUCIONAL",
        "tipos": [
            {
                "id": 8,
                "nombre": "COMUNICACIONES y GESTION INSTITUCIONAL",
                "cuentas": [
                    {
                        "id": 36,
                        "cod": "4510305002",
                        "nomcta": "Folleteria",
                        "total_presupuesto": 300000,
                        "total_gastos": 0,
                        "saldo": 300000
                    },
                    {
                        "id": 40,
                        "cod": "4510305006",
                        "nomcta": "Eventos",
                        "total_presupuesto": 7300000,
                        "total_gastos": 8898,
                        "saldo": 7291102
                    },
                    {
                        "id": 41,
                        "cod": "4510305007",
                        "nomcta": "Fotografía",
                        "total_presupuesto": 500000,
                        "total_gastos": 0,
                        "saldo": 500000
                    }
                ]
            }
        ],
        "orden": 4
    },
 
]

*/
        this.presupuesto_categorias = this.categorias.map((grupo) => ({
          nombre: grupo.nombre,
          total_presupuesto: grupo.tipos
            .flatMap((t) => t.cuentas)
            .reduce((acc, c) => acc + Number(c.total_presupuesto), 0),
          total_gastos: grupo.tipos
                .flatMap(t => t.cuentas)
                .reduce((acc, c) => acc + Number(c.total_gastos || 0), 0),
        }));

       
            this.total_presupuesto_centro = this.presupuesto_categorias.reduce(
                (acc, cat) => acc + Number(cat.total_presupuesto),
                0
            );

            this.total_gastos_centro = this.presupuesto_categorias.reduce(
                (acc, cat) => acc + Number(cat.total_gastos),
                0
            );
            
      } catch (e) {
        console.error("Credenciales inválidas ❌", e);
      }
    },
  },
};
</script>
